import { logError } from './logging';

// Use this function to handle errors without halting execution
export function logException(error: any) {
  // Auto-wrap strings so Sentry gets a stacktrace instead of <unknown>.
  if (typeof error === 'string') {
    error = new Error(error);
  }
  if (goog.DEBUG) {
    console.error(error);
  } else {
    logError(error);
  }
}
